import { render, staticRenderFns } from "./EnterMarksLesson.vue?vue&type=template&id=53526f8a"
import script from "./EnterMarksLesson.vue?vue&type=script&lang=js"
export * from "./EnterMarksLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports